import type { SpellLayers } from '../types/spell-layers'

/** A case-aware membership test over the custom-word and roster layers that are switched on. */
export function buildLayerLookup(layers: SpellLayers): (word: string) => boolean {
  const entries = [
    ...(layers.useCustomWords ? layers.customWords : []),
    ...(layers.useRoster ? layers.rosterWords : []),
  ]
  const normalize = (word: string) => (layers.caseSensitive ? word : word.toLowerCase())
  const known = new Set(entries.map((entry) => normalize(entry.trim())))

  return (word) => known.has(normalize(word))
}
